// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = config.baseURL || config.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
import axios from "axios";
import router from "@/router";

const API_URL = config.VUE_APP_API_URL || "http://localhost:8080";

let configAxios = {
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("token"),
  },
  validateStatus: function (status) {
    return status >= 200 && status < 300; // default
  },
};

const _axios = axios.create(configAxios);

_axios.interceptors.request.use(
  function (config) {
    let token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(undefined, function (err) {
  return new Promise(function () {
    if (err.response.status === 401) {
      localStorage.removeItem("token");
      if (location.pathname != "/login") {
        router.push("/login");
      }
    } else if (err.response.status === 403) {
      alert("Vous n'avez pas les droits nécessaires");
    }

    throw err;
  });
});

export default _axios;
